import React, { useState } from 'react';
import AvatarIcon from 'components/features/utils/AvatarIcon';
import { validateProps } from 'components/features/target-achievement-support/pages/TargetUpdateStep1';
import { toNumber } from 'components/features/target-achievement-support/utils/utils';
import { Errors, Error } from '../../../commons/Error';

export const SetExcludeAmount = ({
  excludeAmount,
  setExcludeAmount,
  validateExcludeAmount,
}: {
  excludeAmount: number;
  setExcludeAmount: (data: number) => void;
  validateExcludeAmount: validateProps;
}) => {
  const [isShow, setIsShow] = useState<boolean>(
    excludeAmount !== 0 ? true : false
  );

  return (
    <>
      <div className="mx-2 mt-8 font-bold text-bluegray-700">
        除外金額の設定
      </div>
      <div className="bg-white mx-2 mt-2 mb-4 h-auto rounded-lg shadow">
        <div className="p-4">
          <div
            className="grid cursor-pointer"
            style={{ gridTemplateColumns: '1fr auto' }}
            onClick={(): void => setIsShow(prev => !prev)}>
            <div className="font-bold text-bluegray-700">
              生活費など投資に使わないお金
            </div>
            <div
              className={`icon-chevron-down ${
                isShow ? 'transform rotate-180' : 'transform rotate-0'
              } transition duration-300 font-bold flex items-center`}></div>
          </div>
          <div
            className={`transition-all duration-300 ${
              isShow
                ? 'ui-effect-fade-in-300 visible'
                : 'ui-effect-fade-out-300 invisible'
            }`}
            style={{
              maxHeight: `${isShow ? 350 : 0}px`,
            }}>
            <div className="pt-4 text-sm text-bluegray-700">
              選択した口座に投資目的以外のお金がある場合は除外してください。残った金額で、貯め方をシミュレーションします。
            </div>
            <div
              className="mt-4 grid items-baseline"
              style={{ gridTemplateColumns: '1fr auto' }}>
              <input
                type="number"
                className={`font-bold text-2xl border rounded-lg py-1 px-4 text-right w-full ${
                  !validateExcludeAmount.isValid
                    ? 'bg-red-150 border-tradewell'
                    : 'border-bluegray-300'
                }`}
                value={excludeAmount}
                onChange={(e): void => {
                  const value = e.target.value;
                  const num = toNumber(value);
                  const amount = num !== null ? num : 0;
                  setExcludeAmount(amount);
                }}
              />
              <div className="font-bold text-sm ml-2 text-bluegray-700">円</div>
            </div>

            {!validateExcludeAmount.isValid && (
              <Errors className="mx-4 mt-1">
                <Error
                  error={{
                    title: 'エラー',
                    description: validateExcludeAmount.error ?? '',
                  }}
                  errorToString={e => e.description}
                />
              </Errors>
            )}
            <div className="mt-6 p-4 rounded-lg border-bluegray-300 border bg-bluegray-100">
              <div className="flex flex-row items-center">
                <AvatarIcon icon="average" />
                <div className="ml-4 font-bold">
                  <div className="text-teal-500 text-xs">設定のヒント</div>
                  <div className="mt-1 text-bluegray-700 text-sm">
                    除外金額の例
                  </div>
                </div>
              </div>
              <div className="mt-2 text-bluegray-700 text-sm">
                ・生活防衛費（参考：生活費約6ヶ月分）
                <br />
                ・その他、投資に使わないお金
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
